import { Component, OnInit } from '@angular/core';
import { ApiResult, PromiseResult } from 'src/app/models/PromiseResult';
import {
  CreateUser,
  VendorSelectedValue,
  get_selected_item,
  get_States,
  p_get_States,
  ConsultationSelectedValue
} from 'src/app/models/supportcreateuser';
import { SupportService } from 'src/app/services/support.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { BreadcrumbService } from 'src/app/components/patient/shared/breadcrumb.service';
import { SelectItem } from 'primeng';
import { CountriesService } from 'src/app/services/countries.service';
import { CountrySelectedValue } from 'src/app/models/doctorregistration';
import { DaterenderService } from 'src/app/services/daterender.service';
import { NgForm } from '@angular/forms';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: [
    './user-create.component.css',
    '../../../../../assets/css/custom-egd.css'
  ]
})
export class UserCreateComponent implements OnInit {
  createUser: CreateUser = new CreateUser();
  consultDoctorForm: NgForm;
  has_consented = false;
  provider_id: string = "";
  slug: string = "";
  gender_list: SelectItem[] = [
    {
      label: 'Male',
      value: 'Male'
    },
    {
      label: 'Female',
      value: 'Female'
    },
    {
      label: 'Other',
      value: 'Other'
    }
  ];

  constructor(
    private readonly utilitiesService: UtilitiesService,
    private readonly SupportService: SupportService,
    private readonly router: Router,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly countriesService: CountriesService,
    private readonly daterenderService: DaterenderService,
    private readonly providerStateService: ProviderStateService
  ) {
   
    const today = new Date();
    this.createUser.other_data.currentDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
  }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerStateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink:['/', this.slug, 'support'] },
      { label: 'Create Request' }
    ]);
    this.provider_id = this.providerStateService.getProviderId();
    await this.getCountries();
    await this.getCountriesCodes();
    await this.getVendorList();
    // await this.getConsultationTypes();
  }

  async getCountries(): Promise<void> {
    await this.countriesService
      .getCountries(this.provider_id)
      .toPromise()
      .then((countries) => {
        countries.forEach((ele) => {
          let data: get_selected_item = {
            id: Number(ele.id),
            is_national_license: ele.is_national_license,
            phone_code: '+' + String(ele.phone_code),
            name: ele.country_name
          };
          ele['final_value'] = data;
        });
        this.createUser.other_data.countries =
          this.utilitiesService.getSelectItemList(
            countries,
            'country_name',
            'final_value'
          );
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async getCountriesCodes(): Promise<void> {
    await this.countriesService
      .getCountries(this.provider_id,true)
      .toPromise()
      .then((countries) => {
        countries.forEach((ele) => {
          ele['final_phone_code'] = '+' + String(ele.phone_code);
          ele['final_label_string'] =
            ele.acronym + ' (' + '+' + String(ele.phone_code) + ')';
        });
        this.createUser.other_data.countries_codes =
          this.utilitiesService.getSelectItemList(
            countries,
            'final_label_string',
            'final_phone_code'
          );
        this.createUser.other_data.countries_codes_secondart =
          this.utilitiesService.getSelectItemList(
            countries,
            'final_label_string',
            'final_phone_code'
          );
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async getVendorList(): Promise<void> {
    await this.SupportService.fetchVendorList()
      .toPromise()
      .then((vendor_list) => {
        vendor_list.data.forEach((ele, index) => {
          let data: VendorSelectedValue = {
            vendor_guid: ele.vendor_guid,
            country_id: ele.country_id,
            vendor_name: ele.vendor_name
          };
          ele['final_value'] = data;
          this.createUser.other_data.vendor_name = data.vendor_name;
          this.createUser.other_data.vendor_guid = data.vendor_guid;
        });
        this.createUser.other_data.vendor_list =
          this.utilitiesService.getSelectItemList(
            vendor_list.data,
            'vendor_name',
            'final_value'
          );
      })
      .catch((err) => {
        console.error(err);
      });
    // await this.reset_defaults();
  }

  async reset_defaults() {
    await this.onChangeVendor();
  }

  async onChangeCountry() {
    await this.countriesService
      .getStates(this.createUser.other_data.selected_primary_country?.id)
      .toPromise()
      .then((states) => {
        states.forEach((ele, index) => {
          let data: get_States = {
            id: ele.id,
            name: ele.state_name
          };
          ele['final_value'] = data;
        });
        this.createUser.other_data.states =
          this.utilitiesService.getSelectItemList(
            states,
            'state_name',
            'final_value'
          );
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async onChangePermanentCountry() {
    await this.countriesService
      .getStates(this.createUser.other_data.selected_permanent_country?.id)
      .toPromise()
      .then((states_p) => {
        states_p.forEach((ele, index) => {
          let data: p_get_States = {
            id: ele.id,
            name: ele.state_name
          };
          ele['final_value'] = data;
        });
        this.createUser.other_data.p_states =
          this.utilitiesService.getSelectItemList(
            states_p,
            'state_name',
            'final_value'
          );
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async onChangeConsultationType() {
    this.createUser.other_data.selected_primary_country =
      this.utilitiesService.findItemByKeyValueSelectItem(
        this.createUser.other_data.countries,
        'id',
        this.createUser.other_data.selected_consultation_type.country_id
      ).value;
    await this.onChangeCountry();
    this.createUser.other_data.consultation_type_id =
      this.createUser.other_data.selected_consultation_type.consultation_type_id;
  }

  async onChangeVendor() {
    await this.getConsultationTypes();
    // this.createUser.other_data.selected_consultation_type = null;
  }

  async userCreationSubmit(form: NgForm) {
    this.createUser.create_api_result = new ApiResult(true);
    this.createUser.supporCreateUser.vendor_guid =
      this.createUser.other_data.selected_vendor_data.vendor_guid;

    this.createUser.supporCreateUser.country_id = Number(
      this.createUser.other_data.selected_primary_country.id
    );

    this.createUser.supporCreateUser.permamnent_country_id = Number(
      this.createUser.other_data.selected_permanent_country.id
    );

    this.createUser.supporCreateUser.primary_contact_number =
      this.createUser.other_data.selected_primary_country.phone_code +
      this.createUser.other_data.primary_contact_no;

    this.createUser.supporCreateUser.secondary_contact_number =
      this.createUser.other_data.selected_secondary_country.phone_code +
      this.createUser.other_data.secondary_contact_no;


    this.createUser.supporCreateUser.state_id = Number(
      this.createUser.other_data.selected_state.id
    );
    this.createUser.supporCreateUser.permamnent_state_id = Number(
      this.createUser.other_data.selected_permanent_state.id
    );

    this.createUser.supporCreateUser.consultation_type_id = Number(
      this.createUser.other_data.consultation_type_id
    );
    this.createUser.supporCreateUser.date_of_birth =
      this.daterenderService.render_data(
        this.createUser.supporCreateUser.date_of_birth_date
      );
    // this.createUser.supporCreateUser.expiry_date =
    //   this.daterenderService.render_data(
    //     this.createUser.supporCreateUser.expiry_Date_date
    //   );
    if (this.createUser.supporCreateUser.e_email == '') {
      this.createUser.supporCreateUser.e_email = null;
    }
    if (this.createUser.supporCreateUser.address == '') {
      this.createUser.supporCreateUser.address = null;
    }
    if (this.has_consented) {
      this.createUser.supporCreateUser.has_consented = true;
    } else {
      this.createUser.supporCreateUser.has_consented = false;
    }
    await this.SupportService.createUser(this.createUser.supporCreateUser)
      .toPromise()
      .then(async (result) => {
        this.createUser.create_api_result.PromiseResult = result;
        if (result.success) {
          this.createUser.resetData();
          this.has_consented = false;
          Object.keys(form.controls).forEach((controlName) => {
            const control = form.controls[controlName];
            control.markAsPristine();
            control.markAsUntouched();
          });
          // await this.reset_defaults();
          this.createUser.display = false;
        }
        this.createUser.create_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.createUser.create_api_result.ServerError = error.error;
        this.createUser.create_api_result.PromiseResult.success = false;
        this.createUser.create_api_result.Posting = false;
      });

  }

  isPosting(): boolean {
    return this.createUser.create_api_result.Posting;
  }

  openDialog() {
    this.createUser.display = true;
    this.createUser.create_api_result = new ApiResult(false);
  }

  closeDialog() {
    this.createUser.display = false;
  }

  async getConsultationTypes(): Promise<void> {
    await this.SupportService.fetchConsultationTypes(
      this.createUser.other_data.selected_vendor_data.vendor_guid
    )
      .toPromise()
      .then((result) => {
        this.createUser.consultations_api_result.PromiseResult = result;
        if (result.success) {
          this.createUser.other_data.consultation_type_list =
            result.data.consultation_list;
        }
        this.createUser.consultations_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.createUser.consultations_api_result.ServerError = error.error;
        this.createUser.consultations_api_result.PromiseResult.success = false;
        this.createUser.consultations_api_result.Posting = false;
      });
  }
}
